import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperationLogRoutingModule } from './operation-log-routing.module';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {AutoCompleteModule, CalendarModule, CheckboxModule, GrowlModule, MultiSelectModule} from "primeng/primeng";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {OperationLogComponent} from './operation-log.component';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    CoreModule,
    TableModule,
    MultiSelectModule
  ],
  exports: [
    OperationLogComponent
  ],
  declarations: [OperationLogComponent]
})
export class OperationLogModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/operation-log/operation-log.module.ts